import React from 'react';
import { LinkGroup as LinkGroupType } from './FooterLinkData';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import Button from 'atoms/Button/Button';

const LinkGroup = ({ title, links }: LinkGroupType): JSX.Element => (
  <Stack
    direction='column'
    gap='spacing-lg'
    align='flex-start'
    justify='flex-start'
  >
    <Typography
      className='footer-group'
      size='md'
      type='paragraph'
      color='text-quaternary-on-brand'
      fontWeight='font-weight-semibold'
    >
      {title}
    </Typography>
    {links.map((link, linkIndex) => (
      <Button
        variant='text-link'
        key={`link-${linkIndex}`}
        className='footer-link'
        href={link.url}
      >
        {link.text}
      </Button>
    ))}
  </Stack>
);

export default LinkGroup;
